import React from "react";
import { Chip } from "@mui/material";
// IN TRANSIT -> DELIVERING
 
// IN PROGRESS -> LOADING
 
// Status mapping from API to display
export const STATUS_MAPPING = {
  inProgress: "Loading",
  paused: "Paused",
  unload: "Unloaded",
  inTransit: "Delivering",
  readyForDelivery: "Ready for Delivery",
  delivered: "Delivered",
  canceled: "Canceled",
};

const OrderStatusChip = ({ status }) => {
  const configs = {
    loaded: { color: "#9E9E9E", label: "Loaded" },
    inProgress: { color: "#2196F3", label: "Loading" },
    paused: { color: "#FF9800", label: "Paused" },
    unload: { color: "#9C27B0", label: "Unloaded" },
    readyForDelivery: { color: "#00BCD4", label: "Ready for Delivery" },
    inTransit: { color: "#3F51B5", label: "Delivering" },
    delivered: { color: "#4CAF50", label: "Delivered" },
    canceled: { color: "#F44336", label: "Canceled" },
    Returned: { color: "#9E9E9E", label: "Returned" },
    returned: { color: "#9E9E9E", label: "Returned" },
    Failed: { color: "#F44336", label: "Failed" },
    failed: { color: "#F44336", label: "Failed" },
    "Partial Returned": { color: "#00bcd7", label: "Partial Returned" },
    "partial returned": { color: "#00bcd7", label: "Partial Returned" },
    "Partial Delivered": { color: "#00bcd7", label: "Partial Delivered" },
    "partial delivered": { color: "#00bcd7", label: "Partial delivered" },
  };

  const config = configs[status] || configs.loaded;

  return (
    <Chip
      label={config.label}
      size="small"
      sx={{ color: config.color, borderColor: config.color }}
      variant="outlined"
    />
  );
};

export default OrderStatusChip;
